import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Link } from "react-router-dom";
import bannerImage from "../../Images/student-services/research-banner.webp";
const RefundPolicy = () => {
    const [modalShow, setModalShow] = React.useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const policyData = [
        {
            id: 1,
            icon: "ti-certificate",
            title: "Eligibility for Refunds",
            content: (
                <>
                    <p>
                        Refunds may be granted under the following conditions:
                    </p>
                    <ul className="mb-0">
                        <li>
                            <b>1.1 Course Cancellation:</b> Full refund if course is cancelled by ISBM University.
                        </li>
                        <li>
                            <b>1.2 Withdrawal Before Start:</b> Eligible for partial/full refund depending on timing.
                        </li>
                        <li>
                            <b>1.3 Non-Refundable Fees:</b> Registration/admin fees may not be refundable.
                        </li>
                    </ul>
                </>
            ),
        },
        {
            id: 2,
            icon: "ti-mail",
            title: "Refund Requests",
            content: (
                <>
                    <p>
                        To request a refund, you must contact ISBM University by email at support@isbm.org.in with your order details and the reason for the refund request.
                    </p>
                    <p>
                        Your refund request must include the following information:
                    </p>
                    <ul>
                        <li>Your full name</li>
                        <li>Course or service purchased</li>
                        <li>Order/payment reference</li>
                        <li>Reason for refund request</li>
                    </ul>
                </>
            ),
        },
        {
            id: 3,
            icon: "ti-clock",
            title: "Processing Refunds",
            content: (
                <>
                    <p>
                        Once we receive your refund request, we will review the details and notify you of the approval or rejection of your request within [X] business days. If your refund is approved, we will process the refund to your original payment method.
                    </p>
                    <ul>
                        <li>
                            <b>3.1 Timing:</b> Refunds processed within [X] business days.
                        </li>
                        <li>
                            <b>3.2 Deduction:</b> Non-refundable fees deducted before refund.
                        </li>
                    </ul>
                </>
            ),
        },
        {
            id: 4,
            icon: "ti-alert-triangle",
            title: "Late or Missing Refunds",
            content: (
                <>
                    <p>
                        If you have not received your refund within the expected time frame, please follow these steps:
                    </p>
                    <ul>
                        <li>Check bank/credit card for pending transactions.</li>
                        <li>Contact your bank for delays.</li>
                        <li>
                            Still pending? Email <b>info@isbmuniversity.edu.in</b>.
                        </li>
                    </ul>
                </>
            ),
        },
        {
            id: 5,
            icon: "ti-ban",
            title: "No Refunds After Commencement",
            content: (
                <p>
                    Refunds will not be provided once a course has commenced, except in exceptional circumstances such as medical emergencies. In such cases, documentation may be required, and refunds will be granted at the sole discretion of ISBM University.
                </p>
            ),
        },
        {
            id: 6,
            icon: "ti-discount",
            title: "Special Offers & Discounts",
            content: (
                <p>
                    ISBM University reserves the right to modify or update this Refund Policy at any time. Changes will be posted on this page, and we encourage you to review this policy regularly. Your continued use of our services constitutes acceptance of any changes to this policy.
                </p>
            ),
        },
        {
            id: 7,
            icon: "ti-edit",
            title: "Changes to Policy",
            content: (
                <p>
                    ISBM University reserves the right to modify or update this Refund Policy at any time. Changes will be posted on this page, and we encourage you to review this policy regularly. Your continued use of our services constitutes acceptance of any changes to this policy.
                </p>
            ),
        },
        {
            id: 8,
            icon: "ti-phone-call",
            title: "Contact Information",
            content: (
                <>
                    <p>
                        If you have any questions about our Refund Policy, please contact us at:
                    </p>
                    <ul className="mb-0">
                        <li>ISBM University</li>
                        <li>Phone: +91 8928111111</li>
                        <li>Email: support@isbm.org.in</li>
                    </ul>
                </>
            ),
        },
    ];
    return (
        <>
            <title>Refund Policy | ISBM University | Join Us Today</title>
            <meta
                name="description"
                content="Explore ISBM University's Refund Policy for clear guidelines on cancellations & refunds. Join us today with confidence & secure your educational journey"
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(77, 77, 77, 0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Refund Policy</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <Link
                                        to="/"
                                        style={{ color: "#fff", textDecoration: "none" }}
                                    >
                                        Home
                                    </Link>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Refund Policy
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50 bg-light">
                <div className="container-xxl">
                    <Row>
                        <Col lg={12} className="m-auto">
                            <h2 className="modern-title section-title text-center text-blue mb-5">
                                Refund Policy
                            </h2>

                            <div className="policy-intro mb-4">
                                <h5 className="fw-bold text-decoration-underline">Introduction</h5>
                                <p className="text-justify">
                                    ISBM University is committed to providing the highest quality educational services.
                                    However, we understand that circumstances may arise where you need to request a refund
                                    for a course or service. This Refund Policy outlines the conditions under which refunds
                                    are provided.
                                </p>
                            </div>

                            <Row className="g-4">
                                {policyData.map((item) => (
                                    <Col md={6} key={item.id}>
                                        <div className="feature-card p-4 h-100 bg-white rounded shadow">
                                            <div className="feature-icon mb-3 text-primary">
                                                <i className={`ti ${item.icon} feature-icon-style`}></i>
                                            </div>
                                            <h5 className="fw-bold">
                                                {item.id}. {item.title}
                                            </h5>
                                            {item.content}
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </Col>
                    </Row>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default RefundPolicy;
